import { OrderedMap } from 'immutable'
export default function stubImmutableOrderedMap() {
  return OrderedMap({})
}
